<template>
  <div class="home">
    <Banner/>
    <div class="main">
      <About/>
      <Products/>
    </div>
    <News/>
  </div>
</template>

<script>
import Banner from './Swiper.vue'
import About from './About.vue'
import Products from './Products.vue'
import News from './News.vue'
export default {
  components: {
    Banner,
    About,
    Products,
    News
  },
  
}
</script>

<style scoped>
.main{
  background: url(../../assets/images/background.png)no-repeat top / cover;
}
@media(max-width: 768px){
  .main{
    background: none;
  }
}
</style>

